export default {
    user: {
        name: "admin"
    }
};
